import { render, staticRenderFns } from "./SxTreeView.vue?vue&type=template&id=90e6722a&"
import script from "./SxTreeView.vue?vue&type=script&lang=js&"
export * from "./SxTreeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports